// istanbul ignore file
const daysOfWeek = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6
}

const months = {
  January: 0,
  February: 1,
  March: 2,
  April: 3,
  May: 4,
  June: 5,
  July: 6,
  August: 7,
  September: 8,
  October: 9,
  November: 10,
  December: 11
}

// Parse date in MM/DD/YYYY format in local time
function parseDate (dateStr, time) {
  if (time) {
    const [day, month, year] = dateStr.split('/').map(Number)
    const date = new Date(year, month - 1, day)
    const [, hours, minutes, period] = time.match(/(\d{1,2}):(\d{2})([AP]M)/i)
    let hrs = parseInt(hours)
    if (period.toUpperCase() === 'PM' && hrs !== 12) hrs += 12
    if (period.toUpperCase() === 'AM' && hrs === 12) hrs = 0
    date.setHours(hrs, minutes, 0, 0)
    return date
  }
  const [day, month, year] = dateStr.split('/').map(Number)
  return new Date(year, month - 1, day)
}

// Parse time in hh:mmA format (e.g., 12:00AM) and combine with a date in local time
function parseTime (date, timeStr) {
  if (!timeStr || typeof timeStr !== 'string') return null

  // Try 24-hour format first (e.g., "14:30")
  const match24 = timeStr.match(/^(\d{1,2}):(\d{2})$/)
  if (match24) {
    const [, hours, minutes] = match24
    const result = new Date(date)
    result.setHours(parseInt(hours), parseInt(minutes), 0, 0)
    return result
  }

  // Try 12-hour format (e.g., "12:00AM")
  const match12 = timeStr.match(/^(\d{1,2}):(\d{2})([AP]M)$/i)
  if (match12) {
    const [, hours, minutes, period] = match12
    let hrs = parseInt(hours)
    const mins = parseInt(minutes)
    if (period.toUpperCase() === 'PM' && hrs !== 12) hrs += 12
    if (period.toUpperCase() === 'AM' && hrs === 12) hrs = 0
    const result = new Date(date)
    result.setHours(hrs, mins, 0, 0)
    return result
  }
  return null
}

// Get the current time in local timezone
function getCurrentTime () {
  return new Date()
}

function getMonthlyTriggerDate (year, month, dateParam) {
  if (!isNaN(dateParam)) {
    const day = parseInt(dateParam)
    const date = new Date(year, month, day)
    if (date.getDate() === day) {
      return date
    } else {
      return null
    }
  } else if (dateParam.startsWith('L')) {
    const k = dateParam === 'L' ? 0 : parseInt(dateParam.split('-')[1])
    const lastDay = new Date(year, month + 1, 0).getDate()
    const triggerDay = lastDay - k
    if (triggerDay >= 1) {
      return new Date(year, month, triggerDay)
    } else {
      return null
    }
  } else {
    throw new Error('Invalid date parameter')
  }
}

function calculateDaily (startDate, endDate, time) {
  const start = parseDate(startDate, '12:00AM')
  const end = parseDate(endDate, '11:59PM')
  const current = getCurrentTime()

  if (start > end) return 0

  let count = Math.floor((end - start) / (24 * 60 * 60 * 1000)) + 1

  // Adjust count if the current date is within the range and time matters
  if (current >= start && current <= end) {
    const currentDateOnly = new Date(current.getFullYear(), current.getMonth(), current.getDate())
    if (currentDateOnly.getTime() === start.getTime()) {
      const triggerTime = parseTime(start, time)
      if (triggerTime <= current) {
        count-- // Exclude the start date if the trigger time has passed or is the same
      }
    }
    if (currentDateOnly.getTime() === end.getTime() && count > 1) {
      const triggerTime = parseTime(end, time)
      if (triggerTime <= current) {
        count-- // Exclude the end date if the trigger time has passed or is the same
      }
    }
  }

  return Math.max(0, count)
}

function calculateWeekly (startDate, endDate, dayOfWeek, time) {
  const start = parseDate(startDate, '12:00AM')
  const end = parseDate(endDate, '11:59PM')
  const current = getCurrentTime()
  if (start > end) return 0

  const targetDow = daysOfWeek[dayOfWeek]
  if (targetDow === undefined) throw new Error('Invalid day of week')

  const startDow = start.getDay()
  const daysToAdd = (targetDow - startDow + 7) % 7
  const firstTrigger = new Date(start.getTime() + daysToAdd * 24 * 60 * 60 * 1000)

  if (firstTrigger > end) return 0

  // Adjust for time on the current date
  const currentDateOnly = new Date(current.getFullYear(), current.getMonth(), current.getDate())
  let adjustedCount = 0
  let currentTrigger = new Date(firstTrigger)

  while (currentTrigger <= end) {
    if (currentTrigger >= start) {
      if (currentTrigger.getTime() === currentDateOnly.getTime()) {
        const triggerTime = parseTime(currentTrigger, time)
        if (triggerTime >= current) {
          adjustedCount++
        }
      } else {
        adjustedCount++
      }
    }
    currentTrigger = new Date(currentTrigger.getTime() + 7 * 24 * 60 * 60 * 1000)
  }

  return adjustedCount
}

function calculateMonthly (startDate, endDate, dateParam, time) {
  const start = parseDate(startDate)
  const end = parseDate(endDate)
  const current = getCurrentTime()
  if (start > end) return 0

  let count = 0
  let year = start.getFullYear()
  let month = start.getMonth()

  while (year < end.getFullYear() || (year === end.getFullYear() && month <= end.getMonth())) {
    const triggerDate = getMonthlyTriggerDate(year, month, dateParam)
    if (triggerDate && triggerDate >= start && triggerDate <= end) {
      const currentDateOnly = new Date(current.getFullYear(), current.getMonth(), current.getDate())
      if (triggerDate.getTime() === currentDateOnly.getTime()) {
        const triggerTime = parseTime(triggerDate, time)
        if (triggerTime >= current) {
          count++
        }
      } else {
        count++
      }
    }
    month++
    if (month > 11) {
      month = 0
      year++
    }
  }
  return count
}

function calculateYearly (startDate, endDate, monthStr, dateParam, time) {
  const start = parseDate(startDate)
  const end = parseDate(endDate)
  const current = getCurrentTime()
  if (start > end) return 0

  const month = months[monthStr]
  if (month === undefined) throw new Error('Invalid month')

  let count = 0
  for (let year = start.getFullYear(); year <= end.getFullYear(); year++) {
    const triggerDate = getMonthlyTriggerDate(year, month, dateParam)
    if (triggerDate && triggerDate >= start && triggerDate <= end) {
      const currentDateOnly = new Date(current.getFullYear(), current.getMonth(), current.getDate())
      if (triggerDate.getTime() === currentDateOnly.getTime()) {
        const triggerTime = parseTime(triggerDate, time)
        if (triggerTime >= current) {
          count++
        }
      } else {
        count++
      }
    }
  }
  return count
}

export function calculateTriggers (params) {
  const { pattern, startDate, endDate, dayOfWeek, date, month, time } = params
  switch (pattern.toLowerCase()) {
    case 'daily':
      return calculateDaily(startDate, endDate, time)
    case 'weekly':
      return calculateWeekly(startDate, endDate, dayOfWeek, time)
    case 'monthly':
      return calculateMonthly(startDate, endDate, date, time)
    case 'yearly':
      return calculateYearly(startDate, endDate, month, date, time)
    default:
      return 0
  }
}

export function isSchedulerPossible (params) {
  const triggers = calculateTriggers(params)
  return triggers > 0
}
